import { Container, Graphics, Rectangle, Text } from 'pixi.js';
import { isMusicOn, toggleMusic, SFX } from '../audio';

// Permanent on-screen music toggle. Owns its own Pixi children;
// caller adds `.view` to stage and calls `setPosition(x, y)` per frame.
export class MusicToggleButton {
  view: Container;
  private bg: Graphics;
  private icon: Text;

  constructor() {
    this.view = new Container();
    this.view.eventMode = 'static';
    this.view.cursor = 'pointer';
    this.bg = new Graphics();
    this.view.addChild(this.bg);
    this.icon = new Text({
      text: '♪',
      style: { fontFamily: 'Courier New', fontSize: 22, fill: 0x00ffcc, fontWeight: 'bold' },
    });
    this.icon.anchor.set(0.5, 0.5);
    this.icon.x = 18; this.icon.y = 18;
    this.view.addChild(this.icon);
    this.view.hitArea = new Rectangle(0, 0, 36, 36);
    this.render();
    this.view.on('pointerover', () => this.render(true));
    this.view.on('pointerout',  () => this.render(false));
    this.view.on('pointertap',  () => { toggleMusic(); SFX.menuClick(); this.render(true); });
  }

  setPosition(x: number, y: number): void {
    this.view.x = x;
    this.view.y = y;
  }

  private render(hovered = false): void {
    const on = isMusicOn();
    this.bg.clear();
    this.bg.roundRect(0, 0, 36, 36, 8);
    this.bg.fill({ color: on ? 0x070716 : 0x1a0a0a, alpha: hovered ? 0.95 : 0.85 });
    this.bg.stroke({ width: 1.5, color: on ? 0x00ffcc : 0xff4466, alpha: hovered ? 1 : 0.7 });
    this.icon.style.fill = on ? 0x00ffcc : 0x553344;
    if (!on) {
      // Strikethrough when muted — diagonal line over the note
      this.bg.moveTo(8, 28);
      this.bg.lineTo(28, 8);
      this.bg.stroke({ width: 2, color: 0xff4466, alpha: 0.95 });
    }
  }
}
